export const articles = [
  {
    id: '1',
    title: '顶流男星深夜密会神秘女子，酒店同框照曝光！粉丝集体破防',
    slug: 'top-star-secret-date-exposed',
    excerpt: '据知情人士透露，某当红顶流男星近日被拍到深夜与一名神秘女子共同进入某高档酒店，两人举止亲密，直到次日清晨才先后离开。粉丝后援会已炸锅，工作室至今未回应。',
    content: `<p>娱乐圈再爆重磅大瓜！据知情人士向吃瓜爆料网独家透露，某当红顶流男星（化名"L先生"）近日被拍到深夜与一名神秘女子共同进入北京某五星级酒店。</p>
<p>据目击者描述，当晚约11点30分，L先生身着黑色卫衣、戴着口罩和棒球帽，低调现身酒店地下车库。约十分钟后，一名身材高挑、穿着时尚的年轻女子也出现在同一地点，两人在电梯口短暂交流后一同进入电梯。</p>
<h2>细节曝光：酒店共度8小时</h2>
<p>更令人震惊的是，两人直到次日早上7点40分左右才先后离开酒店。L先生先行离开，大约15分钟后，该名女子也乘坐一辆黑色商务车离开。整个过程中两人均刻意保持距离，但电梯内的监控画面已被人获取。</p>
<blockquote>圈内人士透露：L先生此前一直维持单身人设，此次被拍将对其商业价值造成重大打击，目前已有至少三个品牌方在考虑解约。</blockquote>
<p>截至目前，L先生的工作室尚未对此事做出任何回应。粉丝后援会内部已出现分裂，部分粉丝选择相信偶像，另一部分则表示"塌房了"。</p>
<h2>网友热议</h2>
<p>此事迅速登上微博热搜榜首，话题#L先生恋情曝光#阅读量在短短三小时内突破5亿。不少网友表示："又一个维持人设的崩塌了"，也有理智粉丝呼吁"等官方回应"。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20luxury%20hotel%20entrance%20at%20night%20with%20silhouette%20of%20two%20people%20walking%20separately%2C%20paparazzi%20style%20photography%2C%20dramatic%20lighting%2C%20warm%20golden%20street%20lamps%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20blurred%20background%20with%20bokeh%20lights%2C%20high%20contrast%2C%20editorial%20style&width=800&height=500&seq=gossip-article-01&orientation=landscape',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    tags: ['顶流', '恋情曝光', '酒店', '塌房'],
    author: '吃瓜前线记者',
    published_at: '2026-06-28T22:30:00Z',
    views: 125800,
    is_hot: true,
    is_featured: true,
  },
  {
    id: '2',
    title: '网红主播偷税被罚2.8亿！直播间已被永久封禁，背后MCN连夜解约',
    slug: 'influencer-tax-evasion-280m-fine',
    excerpt: '某头部带货主播因偷逃税款被税务部门查处，追缴税款加罚款共计2.8亿元。该主播名下所有社交账号已被永久封禁，所属MCN机构火速切割。',
    content: `<p>据国家税务总局最新通报，知名网红主播"小Y"（化名）因涉嫌通过隐匿个人收入、虚构业务转换收入性质等方式偷逃税款，被依法追缴税款、加收滞纳金并处罚款，共计2.8亿元。</p>
<h2>偷税手段曝光</h2>
<p>经查，小Y在2024年至2026年期间，通过设立个人独资企业、合伙企业等方式，将个人直播带货收入转换为企业经营收入，进行虚假申报，偷逃个人所得税超过1.2亿元。</p>
<blockquote>税务部门表示：网络直播行业不是法外之地，税务部门将持续加强对文娱领域和网络直播行业的税收监管。</blockquote>
<p>目前，小Y在各大平台的直播间已被永久封禁，其拥有3000万粉丝的社交账号也全部被清空。所属MCN机构火速发布声明，宣布与小Y解除全部合作关系。</p>
<h2>行业震动</h2>
<p>此事件在直播带货行业引发强烈震动，多位头部主播紧急自查税务情况。业内人士透露，近期将有一批主播主动补缴税款。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20a%20luxurious%20livestreaming%20studio%20with%20ring%20lights%20turned%20off%2C%20dark%20atmosphere%2C%20abandoned%20feeling%2C%20scattered%20luxury%20products%20on%20table%2C%20empty%20chair%2C%20cold%20blue%20and%20gray%20tones%2C%20cinematic%20lighting%2C%20moody%20editorial%20photography&width=800&height=500&seq=gossip-article-02&orientation=landscape',
    category: 'wanghong-fanche',
    categoryName: '网红翻车',
    tags: ['偷税', '直播带货', '网红', '封禁'],
    author: '税务线记者',
    published_at: '2026-06-28T16:00:00Z',
    views: 98600,
    is_hot: true,
    is_featured: true,
  },
  {
    id: '3',
    title: '综艺节目录制现场爆发激烈冲突！两位导师当场翻脸，节目组紧急叫停',
    slug: 'variety-show-fight-on-set',
    excerpt: '某热门选秀综艺录制现场，两位常驻导师因选手评分问题爆发激烈争执，现场一度失控。工作人员紧急介入，录制被迫中断三小时。',
    content: `<p>吃瓜爆料网独家获悉，某热门选秀综艺在最新一期录制过程中，两位常驻导师因对同一名选手的评分产生严重分歧，从激烈争论升级为当面冲突。</p>
<h2>冲突全记录</h2>
<p>据现场工作人员透露，事发于当天下午的选手表演环节。一名选手表演结束后，导师A给出了9.5分的高分，而导师B仅给了5.0分的低分。导师A当场质疑导师B"不懂音乐"，导师B反唇相讥称导师A"在带节奏"。两人随后在录制现场大吵起来，气氛一度非常紧张。</p>
<blockquote>现场观众描述："两人拍桌子站起来对吼，麦克风都被摔了。导演大喊'卡'，工作人员冲上去把两人拉开。"</blockquote>
<p>节目组最终决定暂停录制三小时，分别与两位导师进行谈话。据悉，该期节目将进行重新剪辑，争议片段可能被全部删除。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Dramatic%20TV%20studio%20set%20with%20colorful%20stage%20lights%2C%20two%20empty%20red%20judges%20chairs%20facing%20each%20other%2C%20tense%20atmosphere%2C%20scattered%20papers%20on%20floor%2C%20spotlight%20beams%2C%20dark%20surroundings%2C%20theatrical%20dramatic%20composition%2C%20warm%20red%20and%20amber%20stage%20lighting&width=800&height=500&seq=gossip-article-03&orientation=landscape',
    category: 'zongyi-neimu',
    categoryName: '综艺内幕',
    tags: ['综艺', '冲突', '选秀', '导师'],
    author: '综艺线记者',
    published_at: '2026-06-27T20:00:00Z',
    views: 87200,
    is_hot: true,
    is_featured: false,
  },
  {
    id: '4',
    title: '知名导演被曝片场霸凌演员！多名群演联合发声，视频证据流出',
    slug: 'director-bullying-on-set-exposed',
    excerpt: '某知名商业片导演被多名群众演员联合指控在片场存在言语霸凌和人身攻击行为。一段长达8分钟的片场录音在网上疯传。',
    content: `<p>娱乐圈"潜规则"再添新料。近日，多位曾参与某知名导演剧组拍摄的群众演员联合向吃瓜爆料网爆料，指控该导演在片场存在严重的霸凌行为。</p>
<h2>音频证据流出</h2>
<p>一段长达8分钟的片场录音在网上迅速传播。录音中可以清晰听到该导演用极其粗暴的语言辱骂一名群演，持续时间长达数分钟，其中包含大量人身攻击和侮辱性词汇。</p>
<blockquote>"他已经不是第一次这样了，我们群演在他眼里根本就不是人。"一位不愿透露姓名的爆料者表示。</blockquote>
<p>此事曝光后，多位曾与该导演合作的演员也纷纷在社交媒体上发声，虽未直接点名，但暗示自己也有类似经历。</p>
<h2>行业反思</h2>
<p>该事件引发了影视行业对片场工作环境的广泛讨论。多位业内人士呼吁建立更完善的片场投诉机制，保护基层工作人员的基本权益。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Empty%20movie%20set%20with%20directors%20chair%20and%20megaphone%2C%20dark%20dramatic%20shadows%2C%20film%20equipment%20scattered%2C%20lonely%20atmosphere%2C%20warm%20spotlight%20on%20empty%20chair%2C%20cinematic%20composition%2C%20moody%20and%20tense%20vibe%2C%20behind%20the%20scenes%20photography%20style&width=800&height=500&seq=gossip-article-04&orientation=landscape',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    tags: ['导演', '片场霸凌', '群演', '爆料'],
    author: '影视线记者',
    published_at: '2026-06-27T10:00:00Z',
    views: 75400,
    is_hot: true,
    is_featured: false,
  },
  {
    id: '5',
    title: '某女星豪门婚姻亮红灯！老公被拍到与女模特同游日本',
    slug: 'actress-marriage-crisis-japan-trip',
    excerpt: '圈内公认的"模范夫妻"也翻车了？某知名女星的富商老公被拍到与一位年轻女模特同游东京，两人在银座逛街、共进晚餐的画面被全程记录。',
    content: `<p>娱乐圈"模范夫妻"的神话又碎了一对。吃瓜爆料网收到独家投稿，某知名一线女星（化名"M女士"）的富商老公近日被拍到与一位年轻女模特同游日本东京。</p>
<h2>全程记录：银座约会</h2>
<p>根据爆料人提供的照片，两人于6月25日下午出现在东京银座的高级购物区。男方为M女士公开的丈夫——某地产集团少东家，女方则被认出是某模特经纪公司签约模特，年仅22岁。</p>
<p>两人先是在银座某奢侈品店购物近两小时，随后前往一家米其林三星日料餐厅共进晚餐。整个过程中，两人举止亲密，毫不避嫌。</p>
<blockquote>圈内人士分析：M女士目前正在横店拍戏，完全不知情。这个爆料一旦确认，恐怕是今年最大的婚姻大瓜。</blockquote>
<p>截至发稿，M女士及其丈夫均未对此事做出回应。但M女士的社交媒体已悄然删除了所有与丈夫的合照。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Luxury%20shopping%20street%20in%20Tokyo%20Ginza%20at%20dusk%2C%20elegant%20couple%20silhouettes%20walking%20apart%2C%20warm%20golden%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20romantic%20yet%20mysterious%20atmosphere%2C%20cinematic%20street%20photography%2C%20soft%20bokeh%20background&width=800&height=500&seq=gossip-article-05&orientation=landscape',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    tags: ['婚姻', '出轨', '豪门', '日本'],
    author: '情感线记者',
    published_at: '2026-06-26T14:00:00Z',
    views: 112300,
    is_hot: true,
    is_featured: true,
  },
  {
    id: '6',
    title: '选秀节目投票造假实锤！前工作人员曝光内部操作流程',
    slug: 'talent-show-vote-fraud-exposed',
    excerpt: '某选秀节目的前工作人员匿名向吃瓜爆料网提供了完整的投票造假证据链，包括内部聊天记录、数据修改后台截图等，揭开选秀圈的黑幕。',
    content: `<p>选秀节目的"公正投票"原来全是演戏？吃瓜爆料网收到一份来自某选秀节目前工作人员的匿名爆料，揭示了选秀节目投票造假的完整操作流程。</p>
<h2>造假全流程曝光</h2>
<p>据爆料人提供的内部聊天记录显示，节目组设有专门的"数据组"，负责在每轮投票截止后手动调整选手排名。调整的依据包括选手背后的经纪公司实力、赞助商要求以及节目的戏剧冲突需求。</p>
<blockquote>"投票在后台只是一个可以随意修改的数字。观众投的每一票，其实都抵不过节目组一个后台操作。"爆料人如此表示。</blockquote>
<p>此外，爆料人还提供了后台数据修改界面的截图，清晰显示了选手票数被手动修改前后对比。该证据一经曝光，立刻在网络上引发轩然大波。</p>
<h2>多方回应</h2>
<p>节目组随后发布声明，称"报道内容严重失实，将追究造谣者法律责任"。但多名已淘汰选手在社交媒体上发文暗示，自己确实遭遇了"不公平待遇"。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20glowing%20screens%20showing%20data%20and%20numbers%2C%20mysterious%20atmosphere%2C%20blue%20LED%20lights%2C%20hacker%20vibe%2C%20rows%20of%20computer%20monitors%2C%20cyberpunk%20aesthetic%2C%20dramatic%20shadows%2C%20surveillance%20style%20photography&width=800&height=500&seq=gossip-article-06&orientation=landscape',
    category: 'zongyi-neimu',
    categoryName: '综艺内幕',
    tags: ['选秀', '投票造假', '黑幕', '爆料'],
    author: '深度调查记者',
    published_at: '2026-06-26T09:00:00Z',
    views: 65800,
    is_hot: false,
    is_featured: false,
  },
  {
    id: '7',
    title: '某男团成员被曝私联粉丝！暧昧聊天记录流出，尺度惊人',
    slug: 'boyband-member-secret-fan-relationship',
    excerpt: '当红男团成员被扒出私下与多名粉丝保持暧昧关系，聊天记录包含大量露骨内容。经纪公司紧急发布声明，但粉丝已集体脱粉。',
    content: `<p>偶像与粉丝之间的"红线"再次被踩踏。近日，某当红男团成员（化名"K君"）被爆出私下与多名粉丝保持暧昧关系，大量聊天记录截图在网上疯传。</p>
<h2>聊天记录曝光</h2>
<p>根据曝光的聊天记录，K君通过私人社交账号与至少五名女性粉丝保持联系。聊天内容包含大量暧昧甚至露骨的对话，时间跨度长达两年。最为讽刺的是，K君在公开场合一直宣称"粉丝就是家人"。</p>
<blockquote>一位脱粉的粉丝表示："花了几十万追星，结果发现他在背后同时撩好几个女的，我真的吐了。"</blockquote>
<p>经纪公司第一时间发布声明，承认聊天记录属实，表示K君"深刻反省了自己的不当行为"，将暂停其一切演艺活动进行"自省"。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Dark%20silhouette%20of%20a%20person%20holding%20phone%20with%20glowing%20screen%2C%20chat%20bubbles%20visible%2C%20dim%20bedroom%20lighting%2C%20mysterious%20and%20secretive%20atmosphere%2C%20warm%20amber%20phone%20glow%2C%20voyeuristic%20photography%20style%2C%20intimate%20yet%20tense%20composition&width=800&height=500&seq=gossip-article-07&orientation=landscape',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    tags: ['男团', '私联', '聊天记录', '脱粉'],
    author: '偶像线记者',
    published_at: '2026-06-25T18:00:00Z',
    views: 142000,
    is_hot: true,
    is_featured: true,
  },
  {
    id: '8',
    title: '网红餐厅后厨卫生触目惊心！暗访视频曝光，蟑螂老鼠遍地跑',
    slug: 'internet-famous-restaurant-hygiene-scandal',
    excerpt: '某网红打卡餐厅被暗访曝光后厨卫生状况极差，蟑螂横行、食材过期、厨师不戴手套直接上手。市场监管局已介入调查，门店被责令停业。',
    content: `<p>那些在朋友圈刷屏的"网红美食"，背后到底有多脏？吃瓜爆料网获得一段暗访视频，揭开了某知名网红餐厅后厨的真实面貌，画面令人触目惊心。</p>
<h2>暗访实录</h2>
<p>暗访记者在该餐厅后厨拍摄到：操作台上蟑螂肆意爬行，墙角有老鼠粪便，已过期的食材被继续使用，厨师在未佩戴手套的情况下直接用手处理食材，洗碗池中的水已浑浊发黑却仍在继续使用。</p>
<blockquote>暗访记者描述："走进后厨的一瞬间，一股恶臭扑面而来。地上的油污厚得能粘住鞋底。"</blockquote>
<p>该视频在网上曝光后，播放量迅速突破千万。市场监管局随即介入调查，该餐厅已被责令停业整顿。但令人担忧的是，这只是网红餐饮行业的冰山一角。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Dirty%20dark%20restaurant%20kitchen%20with%20dim%20yellow%20lighting%2C%20greasy%20stainless%20steel%20surfaces%2C%20cluttered%20messy%20countertops%2C%20unhygienic%20atmosphere%2C%20harsh%20shadows%2C%20investigative%20journalism%20style%2C%20gritty%20realistic%20photography%2C%20warm%20sickly%20yellow%20tones&width=800&height=500&seq=gossip-article-08&orientation=landscape',
    category: 'wanghong-fanche',
    categoryName: '网红翻车',
    tags: ['网红餐厅', '卫生', '暗访', '停业'],
    author: '民生线记者',
    published_at: '2026-06-25T08:00:00Z',
    views: 89300,
    is_hot: false,
    is_featured: false,
  },
  {
    id: '9',
    title: '娱乐圈"阴阳合同"再起波澜！某一线演员被曝片酬虚报超3倍',
    slug: 'yin-yang-contract-scandal-actor',
    excerpt: '某一线男演员被举报涉嫌使用阴阳合同逃避税款和片酬限制，实际片酬高达对外公布金额的3倍以上。举报人自称是该演员的前经纪人。',
    content: `<p>阴阳合同的阴影再次笼罩娱乐圈。近日，某一线男演员（化名"Z先生"）的前经纪人实名举报，称Z先生在多部影视作品中使用了阴阳合同，实际片酬远超对外公布金额。</p>
<h2>具体数额曝光</h2>
<p>举报材料显示，Z先生在某古装大剧中对外公布的片酬为3000万元，但通过阴阳合同操作，实际到手金额高达9800万元，中间的差额通过各种方式规避了税收和"限薪令"限制。</p>
<blockquote>举报人表示："我手上掌握了完整的合同原件、银行流水和聊天记录，随时可以提交给相关部门。"</blockquote>
<p>此事一经曝光，立即引发公众对娱乐圈片酬问题的再次关注。多位业内人士表示，阴阳合同在业内并非个案，只是大多数人不愿站出来揭露。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Stack%20of%20legal%20contracts%20and%20documents%20on%20dark%20wooden%20desk%2C%20dramatic%20side%20lighting%2C%20pen%20and%20official%20stamps%2C%20serious%20legal%20atmosphere%2C%20warm%20golden%20desk%20lamp%20light%2C%20shadows%20and%20contrast%2C%20investigative%20journalism%20aesthetic&width=800&height=500&seq=gossip-article-09&orientation=landscape',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    tags: ['阴阳合同', '片酬', '逃税', '限薪令'],
    author: '财经线记者',
    published_at: '2026-06-24T19:00:00Z',
    views: 77800,
    is_hot: false,
    is_featured: false,
  },
  {
    id: '10',
    title: '知名歌手演唱会假唱实锤！技术分析揭露预录音轨，粉丝集体维权',
    slug: 'singer-lip-sync-exposed-concert',
    excerpt: '某知名歌手近期演唱会全程假唱的技术分析视频在B站爆火。专业人士通过音频波形对比，证实演出使用了预录人声。购票粉丝发起集体维权。',
    content: `<p>花了几千块买演唱会门票，结果听了一场"CD播放"？近日，B站UP主"音频侦探"发布了一段技术分析视频，通过专业音频分析软件，证实某知名歌手在近期演唱会上全程使用预录音轨。</p>
<h2>技术分析实锤</h2>
<p>该UP主将演唱会现场录音与歌手的录音室版本进行了波形对比。分析结果显示，现场"演唱"的音频波形与录音室版本的波形完全一致，包括气息、颤音和微小瑕疵都一模一样——这在实际现场演唱中是不可能出现的。</p>
<blockquote>音频专家表示："真正的现场演唱，即使是同一首歌，每次的波形也必然存在差异。完全一致的波形只能说明一个问题——使用了预录音轨。"</blockquote>
<p>视频发布后，大量购票粉丝愤怒表示被骗，已自发组织集体维权。目前已有超过2000名粉丝加入维权群。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20microphone%20stand%20in%20spotlight%2C%20dark%20arena%20with%20empty%20seats%2C%20dramatic%20stage%20lighting%2C%20blue%20and%20purple%20mood%20lights%2C%20lonely%20atmosphere%2C%20after%20show%20vibe%2C%20cinematic%20wide%20angle%20shot%2C%20professional%20concert%20photography&width=800&height=500&seq=gossip-article-10&orientation=landscape',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    tags: ['假唱', '演唱会', '维权', '技术分析'],
    author: '音乐线记者',
    published_at: '2026-06-24T11:00:00Z',
    views: 105600,
    is_hot: false,
    is_featured: false,
  },
  {
    id: '11',
    title: '某大V被曝收钱黑竞争对手！完整聊天记录揭示黑公关产业链',
    slug: 'paid-smear-campaign-exposed-kol',
    excerpt: '某拥有500万粉丝的微博大V被曝收受竞品公司钱财，系统性发布抹黑竞争对手的内容。完整的价格表和操作流程被截图曝光。',
    content: `<p>那些看似"仗义执言"的网络大V，背后可能只是一门生意。吃瓜爆料网独家获得一份黑公关的交易记录，揭开网络黑稿的产业链黑幕。</p>
<h2>明码标价的黑稿</h2>
<p>根据曝光的聊天记录，该大V（化名"老P"）为多个品牌提供"竞品打压"服务，明码标价：一条普通黑稿5万元，一条深度分析黑稿15万元，策划话题热搜50万元起步。服务内容包括编造负面新闻、放大竞品缺陷、引导粉丝攻击等。</p>
<blockquote>知情人士透露："他们有专门的写手团队和话题策划组，一条黑稿从策划到发布不超过24小时，效率极高。"</blockquote>
<p>目前，该大V的账号已被平台限制功能。但业内人士表示，这仅仅是冰山一角，黑公关产业链远比想象中庞大。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Dark%20office%20with%20multiple%20monitors%20showing%20social%20media%20feeds%2C%20shadowy%20figure%20typing%20on%20keyboard%2C%20red%20glowing%20accents%2C%20secretive%20atmosphere%2C%20cyber%20manipulation%20theme%2C%20dramatic%20lighting%2C%20thriller%20movie%20aesthetic%2C%20warm%20display%20glow%20on%20face&width=800&height=500&seq=gossip-article-11&orientation=landscape',
    category: 'wanghong-fanche',
    categoryName: '网红翻车',
    tags: ['黑公关', '大V', '抹黑', '产业链'],
    author: '深度调查记者',
    published_at: '2026-06-23T15:00:00Z',
    views: 56800,
    is_hot: false,
    is_featured: false,
  },
  {
    id: '12',
    title: '某综艺选手被扒学历造假！自称名校毕业实则高中辍学',
    slug: 'reality-show-contestant-fake-degree',
    excerpt: '某热门综艺选手在节目中自称某985名校毕业生，被网友扒出实际仅为高中辍学。更离谱的是，其自称的"海外名校MBA"也被证实纯属虚构。',
    content: `<p>综艺节目的人设到底有多假？某热门综艺选手（化名"H君"）在节目中多次强调自己的"985名校+海外MBA"学历背景，结果被扒出全部是假的。</p>
<h2>学历打假</h2>
<p>网友通过学信网查询，发现H君所说的那所985高校毕业生名单中根本没有他的名字。进一步调查发现，H君实际上在高中二年级时就已辍学，之后从事过多种零工。</p>
<p>更令人震惊的是，H君自称的"美国某知名商学院MBA学位"也被证实纯属虚构——该商学院根本没有H君的入学记录。</p>
<blockquote>节目组回应："我们对选手的背景审核确实存在疏漏，将引以为戒。"</blockquote>
<p>H君本人随后在社交媒体上道歉，称"因为自卑才编造了学历"。但网友并不买账，话题#人设崩塌#迅速登上热搜。</p>`,
    cover_image: 'https://readdy.ai/api/search-image?query=Cracked%20graduation%20certificate%20on%20dark%20surface%2C%20dramatic%20lighting%20from%20side%2C%20symbolic%20broken%20dreams%2C%20empty%20classroom%20in%20background%20blurred%2C%20warm%20sepia%20tones%2C%20nostalgic%20yet%20melancholic%20atmosphere%2C%20conceptual%20photography%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=gossip-article-12&orientation=landscape',
    category: 'zongyi-neimu',
    categoryName: '综艺内幕',
    tags: ['学历造假', '综艺', '人设崩塌', '打假'],
    author: '教育线记者',
    published_at: '2026-06-22T20:00:00Z',
    views: 93400,
    is_hot: false,
    is_featured: false,
  },
];

export const categories = [
  { slug: 'mingxing-tafang', name: '明星塌房', count: 6, description: '明星艺人塌房事件全纪录，内幕爆料不断更新' },
  { slug: 'wanghong-fanche', name: '网红翻车', count: 3, description: '网红主播翻车现场直击，黑料持续追踪' },
  { slug: 'zongyi-neimu', name: '综艺内幕', count: 3, description: '综艺节目幕后真相揭秘，你所不知道的录制现场' },
];

export const tags = [
  { slug: '塌房', name: '塌房', count: 5 },
  { slug: '恋情曝光', name: '恋情曝光', count: 2 },
  { slug: '偷税', name: '偷税', count: 2 },
  { slug: '综艺', name: '综艺', count: 3 },
  { slug: '人设崩塌', name: '人设崩塌', count: 4 },
  { slug: '维权', name: '维权', count: 2 },
  { slug: '黑幕', name: '黑幕', count: 3 },
  { slug: '独家爆料', name: '独家爆料', count: 6 },
  { slug: '直播带货', name: '直播带货', count: 1 },
  { slug: '出轨', name: '出轨', count: 1 },
  { slug: '男团', name: '男团', count: 1 },
  { slug: '假唱', name: '假唱', count: 1 },
];

export const reviews = [
  { name: '资深瓜友小王', rating: 5, content: '吃瓜爆料网是我每天必看的平台！独家消息总比别人快一步，而且料都很真，不像有些营销号天天编故事。推荐所有爱吃瓜的朋友！', date: '2026-06-20' },
  { name: '娱乐圈边缘人', rating: 5, content: '作为半个圈内人，我可以负责任地说这个网站的料90%都是真的。更新速度也很快，很多时候我都是从这先看到消息，然后才在朋友圈发酵。', date: '2026-06-18' },
  { name: '追星十年老粉', rating: 4, content: '虽然有时候看到自家爱豆的爆料会心痛，但不得不说这个平台确实做到了真实、快速、全面。吃瓜还是要吃真瓜！', date: '2026-06-15' },
  { name: '吃瓜路人甲', rating: 5, content: '界面简洁好看，没有乱七八糟的广告弹窗，阅读体验很好。每天蹲更新已经成了习惯，不吃瓜浑身难受哈哈哈！', date: '2026-06-12' },
  { name: '媒体从业者李姐', rating: 5, content: '作为同行，我很佩服这个平台的信息搜集能力和反应速度。很多深度调查报道的质量甚至超过了一些传统媒体。希望越做越好！', date: '2026-06-10' },
  { name: '匿名用户', rating: 5, content: '吃瓜三年了，看着这个平台从小做到大。最欣赏的是他们坚持真实爆料的态度，不造谣不传谣，有料就爆，没料不乱编。良心平台！', date: '2026-06-08' },
];